module.exports = __webpack_public_path__ + "img/dark.15ada1bc.svg";